import axios from "../axiosConfig";

class Routes {
  getAppointments() {
    return axios.get(`/appointment`);
  }
  getAppointment(id) {
    return axios.get(`/appointment/${id}`);
  }
  getAppointmentByUser(id) {
    return axios.get(`/appointment/user/${id}`);
  }
  addAppointment(data) {
    return axios.post("/appointment", data);
  }
  editAppointment(id, data) {
    return axios.patch(`/appointment/${id}`, data);
  }
  deleteAppointment(id) {
    return axios.delete(`/appointment/${id}`);
  }
  approveAppointment(id) {
    return axios.patch(`/appointment/approve/${id}`);
  }
  getReferralAppointments(id, target) {
    return axios.get(
      `/appointment/referral-appointments?target=${target}&id=${id}`
    );
  }
  getNotifications() {
    return axios.get(`/notification`);
  }
  postNotification(data) {
    return axios.post(`/notification`, data);
  }
}

export default new Routes();
